import * as types from '../types';
import * as constants from '../constants';
import { ErrorAction } from '../actions/errors';

export function errors(
    state: types.ErrorsState = {
        hasServerError: false,
        status: 200,
    },
    action: ErrorAction
) {
    switch (action.type) {
        case constants.ADD_SERVER_ERROR:
            return { ...state, hasServerError: true, status: action.payload };
        default:
            return state;
    }
}

export default errors;
